const windowSizes = { x: 0 , y: 0 };
const tabletBreakPoint = 860;
const debug = false;

document.addEventListener( 'DOMContentLoaded' , () => {
    initCollectionGridSliders( debug );
});

function setCurrentWindowDimensions() {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    windowSizes.x = width;
    windowSizes.y = height;
    return;
}
  
function logCurrentWindowDimensions( showConsole = false ) {
    if ( showConsole ) {
        console.log( windowSizes );
    }
    return;
}
  
function isSlickInit( element ) {
    if ( element.classList.contains( 'slick-initialized' ) ) {
        return true;
    }
    return false;
}
  
function initSlick( className , enableArrows ) {
    let arrows = false;
    if ( enableArrows == 'true') {
        arrows = true;
    }
    const widthOfArrows = 15;

    let prevArrow = `<button class="slick-prev"><svg width="${widthOfArrows}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path fill="#bb2025" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></button>`;
    let nextArrow = `<button class="slick-next"><svg width="${widthOfArrows}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path fill="#bb2025" d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></button>`;

    $( className ).slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 3,
        autoplay: !arrows,
        autoplaySpeed: 2000,
        dots: false,
        arrows: arrows,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        responsive: [
            {
                breakpoint: 650,
                settings: {
                    centerMode: true,
                    centerPadding: '60px',
                    slidesToShow: 1,
                    autoplay: !arrows,
                    autoplaySpeed: 2000,
                    dots: false,
                    arrows: arrows,
                    prevArrow: prevArrow,
                    nextArrow: nextArrow
                }
            }
        ]
    });
    return;
}

function destroySlick( className ) {
    $( className ).slick('unslick');
    return;
}

function initCollectionGridSliders( showConsole = false ) {
    setCurrentWindowDimensions();
    logCurrentWindowDimensions( showConsole );

    if ( showConsole ) {
        console.log( 'initializing Collection Grid Sliders' ); 
    }

    const hpCollectionGrids = document.querySelectorAll('[data-enable-slideshow="true"]');
    for ( let slider of hpCollectionGrids ) {
        const currentUniqueClass = slider.classList[ slider.classList.length - 1 ];
        if ( windowSizes.x < tabletBreakPoint && ( isSlickInit( slider ) == false ) ) {
            //run slick
            const enableArrows = slider.getAttribute('data-enable-slideshow-arrows');
            initSlick( `.${currentUniqueClass}` , enableArrows );
        } else if ( windowSizes.x >= tabletBreakPoint && isSlickInit( slider ) == true ) { 
            // check if slick exists and we are above the threshold
            destroySlick( `.${currentUniqueClass}` );
        }
    }

    return;
}

window.addEventListener( 'resize' , ( ) => {
    initCollectionGridSliders( debug );
});
